import {events} from './events'
import Confirm from './confirm'

const ConfirmPlugin = {
  install(Vue, options) {
    Vue.component('confirm', Confirm)

    const confirm = params => {
      if (typeof params != 'object' || Array.isArray(params)) {
        let caughtType = typeof params
        if (Array.isArray(params)) caughtType = 'array'

        throw new Error(
          `Options type must be an object. Caught: ${caughtType}. Expected: object`
        )
      }

      if (typeof params === 'object') {
        if (
          params.hasOwnProperty('callback') &&
          typeof params.callback != 'function'
        ) {
          let callbackType = typeof params.callback
          throw new Error(
            `Callback type must be an function. Caught: ${callbackType}. Expected: function`
          )
        }
        events.$emit('show', params)
      }
    }

    Vue.prototype.$confirm = confirm

    confirm.close = () => {
      events.$emit('close')
    }
  }
}

export default ConfirmPlugin

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(ConfirmPlugin)
}